import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from '../../../components/Icon';
import Text from '../../../components/Text';
import Box from '../../../components/layout/Box';

const Item = ({ id, title, subtitle, author, thumbnail }) => {
  const navigate = useNavigate();

  const fullTitle = `${title}${subtitle ? ` - ${subtitle}` : ``}`;

  const handleClick = () => {
    navigate(`/products?i=${id}`);
  };

  return (
    <Box
      className="noselect flex-column justify-content-between py-3"
      style={{
        width: '100%',
        cursor: 'pointer',
        border: '2px solid #e2e2e2',
        borderRadius: 10,
      }}
      onClick={handleClick}
    >
      <Box className="flex-column flex-grow-1 p-3">
        <Box
          className="w-100 align-items-center justify-content-center"
          style={{
            textAlign: 'center',
          }}
        >
          {thumbnail ? (
            <img src={thumbnail} style={{ width: 120, height: 150 }} />
          ) : (
            <Box
              className="align-items-center justify-content-center"
              style={{
                width: 120,
                height: 150,
                background: 'rgba(60,60,67,0.1)',
              }}
            >
              <Icon name="image-outline" color={'#666666'} />
            </Box>
          )}
        </Box>

        <Box
          className="flex-grow-1 flex-column justify-content-center"
          style={{ marginTop: 6, textAlign: 'center' }}
        >
          <Text variant="listItemTitle">{fullTitle}</Text>
          <Text variant="listItemSubtitle">av {author}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default Item;
